import { Form, Select } from "antd";
import * as React from "react";
import { loadSpecification } from "src/business/specification";
import { loadValueCatalog } from "src/business/valueCatalog/apiValueCatalog";
import { onError } from "src/common/onError";
import { ZOption } from "src/types";

import { AttrEditorData, AttrEditorField } from "./AttrEditorField";

type PropsSelectAttrForValueCatalog = {
  initialValues: AttrEditorData;
  value?: string;
  onChange?(newValue?: string): void;
};

const f = (id: AttrEditorField): string => id;

/**
 * Сбрасывать «Атрибут для отображения» нужно только когда пользователь
 * реально сменил каталог. Не сбрасываем при входе в форму, когда
 * `valuesCatalogId` ещё undefined или только подставился из initialValues.
 */
export const shouldResetValueCatalogAttr = (
  curCatalogId: string | undefined,
  initialCatalogId: string | undefined,
): boolean => !!curCatalogId && curCatalogId !== initialCatalogId;

export const SelectAttrForValueCatalog: React.FC<
  PropsSelectAttrForValueCatalog
> = (props) => {
  const { initialValues, value, onChange } = props;
  const curCatalogId = Form.useWatch(f("valuesCatalogId"));
  const [loading, setLoading] = React.useState(false);
  const [options, setOptions] = React.useState<ZOption[]>([]);

  React.useEffect(() => {
    const currentGuard = ++lastGuard;
    if (curCatalogId) {
      setLoading(true);
      if (value) {
        setOptions([{ value, label: value }]);
      } else {
        setOptions([]);
      }
      loadAttributes(curCatalogId)
        .then((list) => {
          if (currentGuard === lastGuard) {
            setOptions(list);
          }
        })
        .finally(() => setLoading(false))
        .catch(onError);
    } else {
      setOptions([]);
    }

    if (
      shouldResetValueCatalogAttr(curCatalogId, initialValues.valuesCatalogId)
    ) {
      onChange?.("");
    }
  }, [curCatalogId]);

  return (
    <Select
      value={value}
      onChange={onChange}
      options={options}
      loading={loading}
    />
  );
};

let lastGuard = 0;

const loadAttributes = async (valueCatalogId: string): Promise<ZOption[]> => {
  const catalog = await loadValueCatalog(valueCatalogId);
  const spec = await loadSpecification("values", catalog.schema.id);
  return (
    spec.definition?.attributes
      .filter(({ type }) => type.name === "string")
      .map(({ name, title }) => ({
        value: name,
        label: `${name} (${title})`,
      })) ?? []
  );
};
